var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var Svg012SgTryShipperguide = function Svg012SgTryShipperguide(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512.147 512.147",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M74.251 296.619a39.814 39.814 0 0 1 18.545-10.518l226.274-56.569a40.167 40.167 0 0 1 7.107-1.101c.728-11.096-3.138-22.436-11.619-30.917-10.308-10.308-24.841-13.814-38.024-10.518L50.26 243.566a39.823 39.823 0 0 0-18.545 10.518c-15.621 15.621-15.621 40.948 0 56.569a39.914 39.914 0 0 0 12.41 8.443l18.473 7.978c-.59-10.949 3.29-22.092 11.653-30.455z",
    fill: "#a0eda2",
    "data-original": "#cee1f2"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M108.576 346.929 60 395.505c-15.621 15.621-15.621 40.948 0 56.569 15.621 15.621 40.948 15.621 56.569 0l48.576-48.576 27.834 64.45a39.868 39.868 0 0 0 8.443 12.41c15.621 15.621 40.948 15.621 56.569 0a39.814 39.814 0 0 0 10.518-18.545l56.569-226.274c3.296-13.183-.21-27.716-10.518-38.024s-24.841-13.814-38.024-10.518L50.26 243.566a39.823 39.823 0 0 0-18.545 10.518c-15.621 15.621-15.621 40.948 0 56.569a39.914 39.914 0 0 0 12.41 8.443l64.451 27.833z",
    style: {
      strokeWidth: 40,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    fill: "none",
    stroke: "#005454",
    strokeWidth: 40,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    "data-original": "#0023c4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.147 209.579h80M377 294.431 433.569 351M159.897 78.652l56.569 56.569m84.852-115.147v80M442.74 78.652l-56.569 56.569",
    style: {
      strokeWidth: 40,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    fill: "none",
    stroke: "#14d64d",
    strokeWidth: 40,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    "data-original": "#ff5cf4"
  }));
};

export default Svg012SgTryShipperguide;